import store from './index';
export const snackbar = {
    success: (message) => store.dispatch('snackbars/createSnackbar', {
        color: 'success',
        text: message
    }, { root: true }),
    warning: (message) => store.dispatch('snackbars/createSnackbar', {
        color: 'warning',
        text: message
    }, { root: true }),
    error: (message) => store.dispatch('snackbars/createSnackbar', {
        color: 'error',
        text: message
    }, { root: true })
};
